import { render, staticRenderFns } from "./CreateWpsRequest.vue?vue&type=template&id=12cb55da"
import script from "./CreateWpsRequest.vue?vue&type=script&lang=js"
export * from "./CreateWpsRequest.vue?vue&type=script&lang=js"
import style0 from "./CreateWpsRequest.vue?vue&type=style&index=0&id=12cb55da&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports